export default {
  methods: {
    filterSelected(listKey, arr) {
      if (listKey?.includes('ALL')) return arr.filter(e => e.id !== 'ALL')
      const result = arr.filter(e => listKey?.includes(e.id))
      return result
    },

    checkMainHasValue(data, key, parentValue) {
      const value = data[key]
      if (!value || value === 'ALL') return
      if (!parentValue?.includes(value)) {
        data[key] = ''
      }
    },
  },
}
